import { getAccessToken } from './authTokens';

export default function authHeader() {
  const token = getAccessToken();
  return token ? { authorization: `Bearer ${token}` } : {};
}
